import BASE_URL from "../config";


/* -------------------- HELPERS -------------------- */
const handleResponse = async (res) => {
  if (!res.ok) {
    const error = await res.text();
    throw new Error(error || `HTTP Error ${res.status}`);
  }
  return res.json();
};

/* -------------------- POSTS -------------------- */

const getPosts = async (token, query = {}) => {
  const res = await fetch(
    `${BASE_URL}/api/posts?${new URLSearchParams(query)}`,
    {
      headers: { "x-access-token": token },
    }
  );
  return handleResponse(res);
};

const getPost = async (postId, token) => {
  const res = await fetch(`${BASE_URL}/api/posts/${postId}`, {
    headers: { "x-access-token": token },
  });
  return handleResponse(res);
};

const getUserLikedPosts = async (likerId, token, query = {}) => {
  const res = await fetch(
    `${BASE_URL}/api/posts/liked/${likerId}?${new URLSearchParams(query)}`,
    {
      headers: { "x-access-token": token },
    }
  );
  return handleResponse(res);
};

const createPost = async (post, user) => {
  const res = await fetch(`${BASE_URL}/api/posts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.token,
    },
    body: JSON.stringify(post),
  });
  return handleResponse(res);
};

const updatePost = async (postId, user, data) => {
  const res = await fetch(`${BASE_URL}/api/posts/${postId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.token,
    },
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

const deletePost = async (postId, user) => {
  const res = await fetch(`${BASE_URL}/api/posts/${postId}`, {
    method: "DELETE",
    headers: { "x-access-token": user.token },
  });
  return handleResponse(res);
};

const likePost = async (postId, user) => {
  const res = await fetch(`${BASE_URL}/api/posts/like/${postId}`, {
    method: "POST",
    headers: { "x-access-token": user.token },
  });
  return handleResponse(res);
};

const unlikePost = async (postId, user) => {
  const res = await fetch(`${BASE_URL}/api/posts/like/${postId}`, {
    method: "DELETE",
    headers: { "x-access-token": user.token },
  });
  return handleResponse(res);
};

const getUserLikes = async (postId, anchor) => {
  const res = await fetch(
    `${BASE_URL}/api/posts/like/${postId}/users?${new URLSearchParams({
      anchor,
    })}`
  );
  return handleResponse(res);
};

/* -------------------- COMMENTS -------------------- */

const getComments = async ({ id }) => {
  const res = await fetch(`${BASE_URL}/api/comments/post/${id}`);
  return handleResponse(res);
};

const getUserComments = async ({ id, query = {} }) => {
  const res = await fetch(
    `${BASE_URL}/api/comments/user/${id}?${new URLSearchParams(query)}`
  );
  return handleResponse(res);
};

const createComment = async (comment, { id }, user) => {
  const res = await fetch(`${BASE_URL}/api/comments/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.token,
    },
    body: JSON.stringify(comment),
  });
  return handleResponse(res);
};

const updateComment = async (commentId, user, data) => {
  const res = await fetch(`${BASE_URL}/api/comments/${commentId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.token,
    },
    body: JSON.stringify(data),
  });
  return handleResponse(res);
};

const deleteComment = async (commentId, user) => {
  const res = await fetch(`${BASE_URL}/api/comments/${commentId}`, {
    method: "DELETE",
    headers: { "x-access-token": user.token },
  });
  return handleResponse(res);
};

/* -------------------- EXPORTS -------------------- */

export {
  getPosts,
  getPost,
  getUserLikedPosts,
  createPost,
  updatePost,
  deletePost,
  likePost,
  unlikePost,
  getUserLikes,
  getComments,
  getUserComments,
  createComment,
  updateComment,
  deleteComment,
};
